export default {
  top_container: {
    slogan: '全球展会展位预订、门票预订',
    inputPlaceholder: '国家，城市，行业，展会名称'
  },
  hot_city: {
    title: '热门展会城市：',
    city1: '上海',
    city2: '深圳',
    city3: '广州',
    city4: '北京',
    city5: '香港',
    city6: '德国',
    city7: '日本',
    city8: '美国',
    city1_hover: '上海展会',
    city2_hover: '深圳展会',
    city3_hover: '广州展会',
    city4_hover: '北京展会',
    city5_hover: '香港展会'
  },
  kindTitle: '展会行业分类',
  hot_recommend: {
    hot_title: '推荐热门展会',
    moreButton: '更多',
    international_hover: '国际展会',
    domestic_hover: '国内展会',
    internationalTitle: '国际展会·即将开展',
    domesticTitle: '国内展会·即将开展',
    distance: '距离',
    day: '天',
    openness: '开展中...',
    timeUpdate: '时间更新中...',
    newTrends_title: '最新动态',
    exhibitionInfo_hover: '展会资讯',
    nuwInfo_title: '最新资讯',
    newExhibition_title: '最新展会',
    hot_country_title: '热门国家',
    country_suffix3: '展览会',
    country_suffix2: '展览',
    country_suffix1: '展',
    service_1: '全球展会资源',
    service_2: '专属服务顾问',
    service_3: '一站式服务',
    service_4: '快速精准匹配',
    service_5: '覆盖99个国家'
  },
  popularRegions: '热门地区',
  hotIndustries: '热门行业',
  topExhibitions: '热门展会'
}
